export const PTO_BALANCE_COLUMNS = [
  {
    Header: "User",
    accessor: "full_name",
    id: "full_name"
  },
  {
    Header: "Manager",
    id: "manager",
    accessor: "manager"
  },
  {
    Header: "Department",
    id: "department",
    accessor: "department"
  },
  {
    Header: "Emploment Status",
    id: "employment_status",
    accessor: "employment_status"
  },
  {
    Header: "Completed",
    accessor: "yearly",
    id: "yearly"
  },
  {
    Header: "Current Reserved",
    accessor: "reserved",
    id: "reserved"
  },

  {
    Header: "Total",
    accessor: "total",
    id: "total"
  },
  {
    Header: "Reserved Within Period",
    accessor: "reservedWithinPeriod",
    id: "reservedWithinPeriod"
  },
  {
    Header: "Total Within Period",
    accessor: "totalWithinPeriod",
    id: "totalWithinPeriod"
  }
];
